<div class="page-resume animated fadeIn">
  <div class="row mb-3">
    <div class="col-6">
      <div class="col-md-4 col-sm-6">
        <app-button variant="secondary" type="button" aria-label="Go Back" (click)="goBack()">
          <i class="fa fa-angle-left"></i>
          Go Back
        </app-button>
      </div>
    </div>
    <div class="col-md-6">
      <h3 class="float-right mr-3 text-right" style="text-align: right;">CUSTOMER INFORMATION</h3>
    </div>
  </div>

  @if (resumeData.clientInfomationTabData(); as client) {
  <app-cliente-information-card
    #headerCard
    size="large"
    [clientID]="resumeData.clientID()"
    [theme]="module">
  </app-cliente-information-card>
  }


  <div class="container-fluid">
    <app-custom-tabs (selectedIndexChanged)="onTabChanged($event)" (tabChange)="onTabChange($event)">

      <!-- ═══ TAB 1: BASIC INFORMATION ═══ -->
      <app-custom-tab title="Basic Information" key="basic">
        @if (visitedTabs().has('basic') || visitedTabs().has(0)) {
        <app-basic-info-tab></app-basic-info-tab>
        }
      </app-custom-tab>

      <!-- ═══ TAB 2: ECO INFORMATION ═══ -->
      <app-custom-tab title="ECO Information" key="eco-info">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('eco-info') || visitedTabs().has(1)) {
          <app-eco-info-tab></app-eco-info-tab>
          }
        </div>
      </app-custom-tab>

      <!-- ═══ TAB 3: UCO ORDERS ═══ -->
      <app-custom-tab title="UCO Orders" key="uco-orders">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('uco-orders') || visitedTabs().has(2)) {
          <app-customer-orders-tab [isVisible]="visitedTabs().has('uco-orders') || visitedTabs().has(2)"
            (orderClicked)="openOrderDetailModal($event)"></app-customer-orders-tab>
          }
        </div>
      </app-custom-tab>

      <!-- ═══ TAB 4: ECO ORDERS ═══ -->
      <app-custom-tab title="ECO Orders" key="eco-orders">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('eco-orders')) {
          <app-customer-eco-orders-tab [isVisible]="visitedTabs().has('eco-orders')"
            [clientId]="resumeData.clientID()"></app-customer-eco-orders-tab>
          }
        </div>
      </app-custom-tab>

      <!-- ═══ TAB 5: OIL COLLECTION RESUME ═══ -->
      @if (hasProject()) {
      <app-custom-tab title="Oil Collection Resume" key="oil-collection">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('oil-collection') || visitedTabs().has(4)) {
          <app-oil-collection-resume-tab [isVisible]="visitedTabs().has('oil-collection') || visitedTabs().has(4)"
            [clientId]="resumeData.clientID()"></app-oil-collection-resume-tab>
          }
        </div>
      </app-custom-tab>

      <!-- ═══ TAB 6: RECONCILIATION ═══ -->
      <app-custom-tab title="Reconciliation" key="reconciliation">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('reconciliation') || visitedTabs().has(5)) {
          <app-reconciliation></app-reconciliation>
          }
        </div>
      </app-custom-tab>
      }

      <!-- ═══ TAB 7: PERFORMANCE SUMMARY ═══ -->
      <app-custom-tab title="Performance Summary" key="performance">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('performance') || visitedTabs().has(hasProject() ? 6 : 4)) {
          <app-client-perfomance-summary [client_data]="raw?.client"></app-client-perfomance-summary>
          }
        </div>
      </app-custom-tab>

      <!-- ═══ TAB 8: QUICKBOOKS FINANCIAL ═══ -->
      <app-custom-tab title="QuickBooks" key="quickbooks">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('quickbooks') || visitedTabs().has(hasProject() ? 7 : 5)) {
          <app-qb-financial-tab
            [isActive]="activeTabKey() === 'quickbooks' || activeTabIndex() === (hasProject() ? 7 : 5)"
            (qbDataChanged)="onQbDataChanged()">
          </app-qb-financial-tab>
          }
        </div>
      </app-custom-tab>

      <!-- ═══ TAB 9: CHANGE LOG ═══ -->
      <app-custom-tab title="Change Log" key="change-log">
        <div class="resume-style" style="width: calc(100% - 12px); margin: auto; margin-top: 20px;">
          @if (visitedTabs().has('change-log') || visitedTabs().has(hasProject() ? 8 : 6)) {
          <app-change-log-tab
            [isActive]="activeTabKey() === 'change-log' || activeTabIndex() === (hasProject() ? 8 : 6)">
          </app-change-log-tab>
          }
        </div>
      </app-custom-tab>

    </app-custom-tabs>
  </div>

</div>
@if (!resumeData.clientInfomationTabData()) {
<app-page-loading [absolute]="true"></app-page-loading>
}